import React, { useEffect, useState } from "react";
import styled from "styled-components";
import BreadCrumb from "../components/Booking/BreadCrumb";
import CartBanner from "../components/MyCart/BannerCart";
import { Colors } from "../ColorConstants";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Footer, { FooterMobile } from "../components/Footer";
import ReactModal from "react-modal";
import Button from "../components/Buttons";
import { Text } from "../TextConstants";
import CustomLoader from "../components/Loader";
import PurchaseDetails, {
  PurchaseDetailsMobile,
} from "../components/MyPurchases/PurchaseDetails";
import { Months } from "../tempConst";
import ReservationContainer from "../components/MyPurchases/ReservationDropDown";
import { Pagination } from "../components/MyPurchases/Pagination";
import { cancelTicket, getPurchaseList } from "../services/userServices";
import { BackArrow, BackButton } from "../assets/icons";

const MyPurchases = () => {
  const todayDate = new Date();
  const [checkoutCustomModal, setCheckoutCustomModal] = useState(false);
  const [warningModal, setWarningModal] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reservation, setReservation] = useState("Upcoming Reservations");
  const [drop, setDrop] = useState(false);
  const [date, setDate] = useState(todayDate);
  const [month, setMonth] = useState(Months[todayDate.getMonth()]);
  const [year, setYear] = useState(todayDate.getFullYear());
  const [type, setType] = useState("all");
  const [filter, setFilter] = useState("upcoming");
  const [isCancelTicket, setCancelTicket] = useState(false);
  const [itemId, setItemId] = useState();

  const navigate = useNavigate();

  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(3);
  const [isTableDataLoading] = useState(false);
  const totalData = data.length;
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = Math.min(startIndex + rowsPerPage, totalData);

  const onPageChange = (page) => {
    setCurrentPage(page);
  };

  const customStyles = {
    content: {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      left: "0",
      top: 0,
      background: "transparent",
      border: "none",
      boxSizing: "border-box",
    },
    overlay: {
      background: Colors.blackOpacity,
      zIndex: 9999,
      display: "flex",
    },
  };

  const getBreadCrumbData = () => {
    return [
      { label: "Home", path: `/auth/home` },
      { label: "My Purchases", path: `/app/reservation` },
    ];
  };

  useEffect(() => {
    fetchPurchaseList(month, type, year, filter);
  }, []);

  const fetchPurchaseList = async (month, type, year, filter) => {
    setLoading(true);
    try {
      let res = await getPurchaseList(month, type, year, filter);
      setData(res?.data?.list);
    } catch (err) {
      toast.error(err.message, { hideProgressBar: true });
    } finally {
      setLoading(false);
    }
  };

  const handleDropClick = (reserve) => {
    let selectedType = "";
    let selectedReserve = "";
    if (reserve !== "") {
      setReservation(reserve);

      switch (reserve) {
        case "Upcoming Reservations":
          selectedType = "all";
          setType("all");
          selectedReserve = "upcoming";
          setFilter("upcoming");
          break;
        case "Restuarant Bookings":
          selectedType = "reservation";
          setType("reservation");
          break;
        case "Entertainment Tickets":
          selectedType = "parks";
          setType("parks");
          break;
        case "Reservation History":
          selectedType = "parks";
          selectedReserve = "history";
          setType("parks");
          setFilter("history");
          break;
        default:
          selectedType = "all";
          setType("all");
          selectedReserve = "upcoming";
          setFilter("upcoming");
          break;
      }
      fetchPurchaseList(month, selectedType, year, selectedReserve);
    }
    setDrop(!drop);
  };

  const handleSelectDate = (date) => {
    setDate(date);
    const selectedYear = date.getFullYear();
    setYear(date.getFullYear());
    const selectedMonth = Months[date.getMonth()];
    setMonth(selectedMonth);
    fetchPurchaseList(selectedMonth, type, selectedYear, filter);
  };
  const onOpenCancelModal = (id) => {
    setCancelTicket(!isCancelTicket);
    setItemId(id);
  };

  const handleCancelTicket = async (reasonText) => {
    const obj = {
      ticketId: itemId,
      reason: reasonText,
    };
    try {
      let res = await cancelTicket(obj);
      if (res.status === 200) {
        fetchPurchaseList(month, type, year, filter);
        setCancelTicket(false);
      }
    } catch (err) {
      toast.error(err.message, { hideProgressBar: true });
    }
  };

  return (
    <>
      <BackImageContainer onClick={() => navigate(`/auth/home`)}>
        <BackImage src={BackButton} />
      </BackImageContainer>
      {/* <CartBanner header={Text.myPurchases} /> */}
      <BreadCrumb
        arrow={false}
        items={getBreadCrumbData()}
        activeItem={"My Purchases"}
      />
      <PurchaseMainContainer>
        <ReservationContainer
          reservation={reservation}
          drop={drop}
          handleDropClick={handleDropClick}
          handleSelectDate={handleSelectDate}
          date={date}
        />
        <PurchaseDetails
          data={data}
          onCancelTicket={handleCancelTicket}
          isCancelTicket={isCancelTicket}
          setCancelTicket={setCancelTicket}
          onOpenCancelModal={onOpenCancelModal}
        />
        <PurchaseMobileContainer>
          <PurchaseDetailsMobile
            data={data}
            isModal={false}
            onOpenCancelModal={onOpenCancelModal}
          />
        </PurchaseMobileContainer>

        {/* {data?.length > 0 && (
          <Pagination
            onPageChange={onPageChange}
            isTableDataLoading={isTableDataLoading}
            totalData={totalData}
            currentPage={currentPage}
            rowsPerPage={rowsPerPage}
            totalPages={Math.ceil(totalData / rowsPerPage)}
          />
      )} */}
      </PurchaseMainContainer>
      {loading ? <CustomLoader /> : <></>}
      <FooterContainer>
        <Footer />
      </FooterContainer>
      <FooterMobile />
      <ReactModal isOpen={warningModal} style={customStyles}>
        <WarningModal>
          <WarningModalHeader>Attention!</WarningModalHeader>
          <WarningModalDescription>
            Kids under 6 years must be accompanied by an adult
          </WarningModalDescription>
          <WarningModalAction>
            <Button
              onClick={() => setWarningModal(false)}
              variant="filled"
              label={"Ok, I Understand"}
              width="15rem"
            />
          </WarningModalAction>
        </WarningModal>
      </ReactModal>
    </>
  );
};
const BackImageContainer = styled.div`
  @media only screen and (max-width: 576px) {
    display: flex;
    position: fixed;
    top: 2rem;
    margin: 0 0 0 0.5rem;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 0.5rem;
    z-index: 1000;
  }
  @media only screen and (min-width: 577px) {
    display: none;
  }
`;
const BackImage = styled.img`
  width: 0.6rem;
  height: 0.8rem;
  padding: 0.8rem;
  resize-mode: contain;
`;
const PurchaseMainContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 5rem;
`;
const PurchaseMobileContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const FooterContainer = styled.div`
  @media only screen and (max-width: 576px) {
    display: none;
  }
`;
const WarningModal = styled.div`
  background: white;
  width: fit-content;
  padding: 2rem 1rem 1rem 1rem;
  border-radius: 0.5rem;
  gap: 1rem;
  display: flex;
  flex-direction: column;
  text-align: center;
  @media only screen and (max-width: 640px) {
    width: 85%;
  }
`;
const WarningModalHeader = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
`;
const WarningModalDescription = styled.div``;
const WarningModalAction = styled.div`
  display: flex;
  justify-content: center;
`;

export default MyPurchases;
